import React from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import LaganCombo from "@/components/site/LaganCombo";
import Categories from "@/components/site/Categories";
import Brands from "@/components/site/Brands";
import About from "@/components/site/About";
import ContactSection from "@/components/site/ContactSection";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";

export default function Home() {
  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <LaganCombo />
        <Categories />
        <Brands />
        <About />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
